import { MDBAlert } from 'mdb-react-ui-kit';
import React, { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deleteIPAddr } from '../../../apiclients/streamsapi_bridge';

const DeleteIPAddress = forwardRef(({ onClose, setIsloading, id, setSuccessMessage, setRerender, setInternalError }, ref) => {
    // const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const removeThisIP = async (e) => {
        try {
            setInternalError(false);
            setIsloading(true);
            let deleteaddressReponse = await deleteIPAddr(JSON.parse(sessionStorage.getItem("admin_session")).siteid, id.ip_address, id.range);
            setTimeout(() => { setIsloading(false) }, 1000);
            let delInfo = await deleteaddressReponse.json();

            if (delInfo.status == 'success') {
                setSuccessMessage(delInfo.message);



            } else {
                setInternalError(delInfo.message);

            }
            // 
            // navigate("/securityregistrationlanding", {
            //     state: { tab: "tab1" },
            // });
            // window.location.reload();
            onClose();
            setRerender(true);
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }

    }
    return (
        <>

            <div>
                <span className="phrecording">{t("RemoveIPAddresstxt")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeThisIP(e)}>
                    {t("remove")}</button>
            </div>

        </>
    )
});

export default DeleteIPAddress
